






























import { defineComponent, onMounted, ref } from '@vue/composition-api';
import { useRouter } from 'vivat';

const Management = defineComponent({
  setup() {
    const dropdownList = ['ชื่อ/นามสกุล'];
    const reports = [
      {
        id: '1',
        title: 'Revenue (รายได้ค่าบริการขนส่ง)',
        subtitle: 'รายละเอียดย่อยขยายเพิ่มเติมว่าคือรายงานอะไร',
        component: 'ReportRevenueInformation',
      },
      {
        id: '2',
        title: 'ปริมาณการจัดส่ง (kg)',
        subtitle: 'รายละเอียดย่อยขยายเพิ่มเติมว่าคือรายงานอะไร',
        component: 'ReportWeightInformation',
      },
      {
        id: '3',
        title: 'อัตราส่วน ค่าขนส่ง THB/kg',
        subtitle: 'รายละเอียดย่อยขยายเพิ่มเติมว่าคือรายงานอะไร',
        component: 'ReportPriceRatioInformation',
      },
      {
        id: '4',
        title: '% Gross Profit / Net Profit',
        subtitle: 'รายละเอียดย่อยขยายเพิ่มเติมว่าคือรายงานอะไร',
        component: 'ReportProfitInformation',
      },
      {
        id: '5',
        title: '% Transportation Cost',
        subtitle: 'รายละเอียดย่อยขยายเพิ่มเติมว่าคือรายงานอะไร',
        component: 'ReportTransportationInformation',
      },
      {
        id: '6',
        title: 'Reverse Logistics',
        subtitle: 'รายละเอียดย่อยขยายเพิ่มเติมว่าคือรายงานอะไร',
        component: 'ReportReverseInformation',
      },
      {
        id: '7',
        title: 'Lead Time',
        subtitle: 'รายละเอียดย่อยขยายเพิ่มเติมว่าคือรายงานอะไร',
        component: 'ReportLeadTimeInformation',
      },
    ];
    const selectedDriver = ref(0);
    const { router } = useRouter();
    const navigationHandler = (name: any) => {
      router.push({ name });
    };
    onMounted(() => {
      navigationHandler('ReportRevenueInformation');
    });
    return {
      dropdownList,
      reports,
      selectedDriver,
      navigationHandler,
    };
  },
});

export default Management;
